import { CURRENT_SERVICE_TYPE, SERVICE_TYPE } from '@utility/checkout-utils';

import { useScaAccountAccessContext } from '../../contexts/ScaAccountAccessContext/ScaAccountAccessContext';
import { useScaPaymentDetailsContext } from '../../contexts/ScaPaymentDetailsContext/ScaPaymentDetailsContext';

import type { ScaSubjectProviderData } from './ScaSubjectProvider.types';

export function useScaSubject(): ScaSubjectProviderData {
  const {
    paymentDetails,
    updatePaymentDetails,
    refetchPaymentDetails,
    cancelPayment,
    ...restPayment
  } = useScaPaymentDetailsContext();

  const {
    accountAccess,
    updateAccountAccess,
    refetchAccountAccess,
    cancelAccountAccess,
    ...restAccountAccess
  } = useScaAccountAccessContext();

  if (CURRENT_SERVICE_TYPE === SERVICE_TYPE.AIS) {
    return {
      subject: accountAccess,
      updateSubject: updateAccountAccess,
      refetchSubject: refetchAccountAccess,
      cancel: cancelAccountAccess,
      ...restAccountAccess,
    };
  }

  return {
    subject: paymentDetails,
    updateSubject: updatePaymentDetails,
    refetchSubject: refetchPaymentDetails,
    cancel: cancelPayment,
    ...restPayment,
  };
}
